import React from 'react';

const MillingReportScreen = () => {
  return <div>Milling Report Screen</div>;
};

export default MillingReportScreen;
